import styled from 'styled-components'

import { palette, shadows } from '../../styles/variables'
import Icon from '../icon/Icon'

const Note = styled.div((props) => ({
  backgroundColor: props.color ? props.color : palette.white,
  color: props.textColor || palette.darkGray,
  boxShadow: shadows.shadowA,
  display: 'flex',
  padding: '16px',
  alignItems: 'center',
}))

const NotePanel = ({ show, icon, ...props }) => {
  if (!show) return null
  return (
    <Note
      color={palette.white}
      textColor={palette.darkGray}
      light
      style={props.style}
    >
      <Icon
        src={icon}
        size="24px"
        margin="0 16px 0 0"
        style={{ cursor: 'default' }}
      />
      {props.children}
    </Note>
  )
}

export default NotePanel
